import {useTheme} from '@mui/material';
import {ChatRoomsEnum} from 'presentation/constants';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useCallChatRoom} from 'presentation/pages';
import {UseScriptModalProps} from './types';

export function useScriptModal({setOpen}: UseScriptModalProps) {
	const bookingData = useBookingStore(state => state.bookingData);
	const setBookingData = useBookingStore(state => state.setBookingData);

	const theme = useTheme();
	const {callChatRoom} = useCallChatRoom();

	const resetSpecialtySelection = () => {
		setBookingData(prev => ({
			...prev,
			specialtyCode: '',
			specialtyName: '',
			subSpecialtyCode: '',
		}));
	};

	const handleClose = () => {
		setOpen(false);
		resetSpecialtySelection();
	};

	const handleCallChat = () => {
		callChatRoom(ChatRoomsEnum.APP);
		setOpen(false);
		resetSpecialtySelection();
	};

	return {
		handleClose,
		handleCallChat,
		bookingData,
		theme,
	};
}
